import {IconProps} from './types';

function TrashIcon({fill = 'none', stroke = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill={fill}>
            <path d="M17.583 3.83337L16.073 18.1742C16.03 18.5837 15.8369 18.9627 15.531 19.2383C15.2251 19.5139 14.8281 19.6665 14.4163 19.6667H5.74967C5.33781 19.6667 4.94053 19.5142 4.63446 19.2386C4.3284 18.963 4.13521 18.5838 4.09217 18.1742L2.58301 3.83337" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M0.5 3.83337H19.6667" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.33301 3.83333V1.33333C6.33301 1.11232 6.42081 0.900358 6.57709 0.744078C6.73337 0.587797 6.94533 0.5 7.16634 0.5H12.9997C13.2207 0.5 13.4327 0.587797 13.5889 0.744078C13.7452 0.900358 13.833 1.11232 13.833 1.33333V3.83333" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.083 7.58337V16.3334" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.8327 7.58337L13.416 16.3334" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.33301 7.58337L6.74967 16.3334" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default TrashIcon;
